import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import 'video-react/dist/video-react.css';
import { Player } from 'video-react';
import moment from 'moment';
import 'moment/locale/pt-br';
import DatePicker from 'react-datepicker';
import ReactCrop from 'react-image-crop';
import api from '../../services/api';

import Select from '../../components/Select';
import TextArea from '../../components/TextArea';
import Loading from '../../components/Loading';
import { Container, ButtonPanel } from './styles';
import 'react-image-crop/dist/ReactCrop.css';

export default class EditPost extends Component {
  state = {
    alert: {},
    crop: {
      aspect: 0.56,
      width: 360,
      x: 0,
      y: 0,
    },
    content_kind: null,
    currentImage: null,
    currentVideo: null,
    description: '',
    kind: null,
    loading: true,
    published_at: null,
    expired_at: null,
    showAlert: false,
  };

  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    match: PropTypes.shape().isRequired,
  };

  componentDidMount() {
    this.loadPost();
    const { kind } = this.state;
    const cropProportion = kind === 'stories' ? 0.56 : 1;
    this.setState({
      crop: { ...this.state.crop, aspect: cropProportion },
    });
  }

  onSelectImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener('load', () => this.setState({ imageSrc: reader.result }));
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  onSelectVideo = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      this.setState({ videoSrc: e.target.files[0] });
    }
  };

  onImageLoaded = (image, pixelCrop) => {
    this.imageRef = image;

    const { crop } = this.state;

    if (crop.aspect && crop.height && crop.width) {
      this.setState({
        crop: { ...crop, height: null },
      });
    } else {
      this.makeClientCrop(crop, pixelCrop);
    }
    this.setState(
      {
        alert: {
          title: 'Posicione e corte a imagem',
          type: 'info',
          messages: ['Clique em cima da imagem quando estiver na posição correta.'],
          onConfirm: () => this.closeAlert(),
        },
      },
      () => {
        this.openAlert();
      },
    );
  };

  onCropComplete = (crop, pixelCrop) => {
    this.makeClientCrop(crop, pixelCrop);
  };

  onCropChange = (crop) => {
    this.setState({ crop });
  };

  getCroppedImg(image, pixelCrop) {
    const canvas = document.createElement('canvas');
    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height,
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        window.URL.revokeObjectURL(this.fileUrl);
        this.fileUrl = window.URL.createObjectURL(blob);
        resolve(this.fileUrl);
        this.setState({ croppedImage: this.blobToFile(blob, 'cover.jpg') });
      }, 'image/jpeg');
    });
  }


  loadPost = async () => {
    try {
      const { data } = await api.get(`posts/${this.props.match.params.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      data.post.published_at = moment(data.post.published_at);
      data.post.expired_at = moment(data.post.expired_at);

      const {
        content_kind,
        description,
        expired_at,
        image,
        kind,
        published_at,
        video,
      } = data.post;

      this.setState({
        content_kind,
        currentImage: image,
        currentVideo: video,
        description,
        expired_at,
        kind,
        published_at,
      });

      this.setState({ loading: false });
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Não foi possível carregar a publicação. Por favor, atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  blobToFile = (theBlob, fileName) => {
    const blob = theBlob;
    blob.lastModifiedDate = new Date();
    blob.name = fileName;
    return theBlob;
  }

  handleSubmit = async (e) => {
    const {
      content_kind,
      croppedImage,
      description,
      kind,
      videoSrc,
    } = this.state;

    e.preventDefault();

    this.setState({ loading: true });

    try {
      const formData = new FormData();
      const checkedDescription = kind === 'feed' ? description : '';
      formData.append('content_kind', content_kind);
      formData.append('description', checkedDescription);
      formData.append('kind', kind);
      if (content_kind === 'image') {
        if (croppedImage) {
          formData.append('image', croppedImage);
        }
      } else {
        formData.append('video', videoSrc);
      }

      const res = await api.put(`posts/${this.props.match.params.id}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });
      this.props.history.push(`/panel/posts/${res.data.id}`);
    } catch (err) {
      this.setState({ loading: false });
      const messages = err.response && err.response.data && err.response.data.errors
        ? err.response.data.errors
        : ['Não foi possível completar a requisição. Por favor, atualize a página.'];
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages,
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleChangeKind = (e) => {
    const cropProportion = e.target.value === 'stories' ? 0.56 : 1;
    this.setState({
      crop: { ...this.state.crop, aspect: cropProportion },
      kind: e.target.value,
    });
  };

  handleChangeContentKind = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      croppedImage: null,
      croppedImageUrl: null,
      imageSrc: null,
      videoSrc: null,
    });
  };

  openAlert = () => {
    this.setState({
      showAlert: true,
    });
  };

  closeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  onConfirm = () => {
    this.setState({
      showAlert: false,
    });
  };

  async makeClientCrop(crop, pixelCrop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(this.imageRef, pixelCrop, 'newFile.jpeg');
      this.setState({ croppedImageUrl });
    }
  }

  render() {
    const {
      alert: {
        cancelBtnText,
        cancelBtnBsStyle,
        confirmBtnText,
        confirmBtnBsStyle,
        messages,
        onConfirm,
        showCancel,
        title,
        type,
      },
      content_kind,
      crop,
      croppedImageUrl,
      currentImage,
      currentVideo,
      description,
      expired_at,
      imageSrc,
      kind,
      loading,
      published_at,
      showAlert,
      videoSrc,
    } = this.state;
    return (
      <Fragment>
        {loading && <Loading />}
        <Container>
          <h1 className="page-title">Editar publicação</h1>
          <div className="box">
            <form onSubmit={this.handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="field-group">
                    <span className="field-title">Data de publicação</span>
                    <DatePicker
                      disabled
                      selected={published_at}
                      placeholderText="Data de publicação"
                      dateFormat="DD/MM/YYYY, HH:mm[h]"
                      timeFormat="HH:mm"
                      timeCaption="Horário"
                      showTimeSelect
                      locale="pt-br"
                    />
                  </div>
                  <div className="field-group">
                    <span className="field-title">Data de expiração</span>
                    <DatePicker
                      disabled
                      selected={expired_at}
                      placeholderText="Data de expiração"
                      dateFormat="DD/MM/YYYY, HH:mm[h]"
                      timeFormat="HH:mm"
                      timeCaption="Horário"
                      showTimeSelect
                      locale="pt-br"
                    />
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="field-group">
                        <span className="field-title">Formato do post</span>
                        <Select
                          name="kind"
                          value={kind}
                          onChange={this.handleChangeKind}
                          description="Tipo de post"
                          options={[
                            { value: 'stories', text: 'Stories' },
                            { value: 'feed', text: 'Feed' },
                          ]}
                        />
                      </div>
                      <div className="field-group">
                        <span className="field-title">Tipo de conteúdo:</span>
                        <Select
                          value={content_kind}
                          name="content_kind"
                          onChange={this.handleChangeContentKind}
                          description="Tipo de conteúdo"
                          options={[
                            { value: 'image', text: 'Imagem' },
                            { value: 'video', text: 'Vídeo' },
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  {kind === 'feed' && (
                    <TextArea
                      name="description"
                      value={description}
                      onChange={this.handleChange}
                      placeholder="Descrição"
                    />
                  )}
                </div>
                <div className="col-12">
                  <div className="field-group upload-group">
                    <span className="field-title">Alterar {content_kind === 'image' ? 'imagem' : 'video'} da publicação:</span>
                    <span className="desc">
                      Extensões suportadas:{' '}
                      {content_kind === 'image' ? 'PNG ou JPG' : 'MP4'}
                    </span>
                    <span className="desc">
                      <strong>Tamanho ideal:</strong>{' '}
                      {kind === 'stories' ? '1080 x 1920px' : '1080 x 1080px'}
                    </span>
                    {content_kind === 'image' ? (
                      <Fragment>
                        <input
                          type="file"
                          accept="image/*"
                          name="imageSrc"
                          onChange={this.onSelectImage}
                        />
                        <div className="row">
                          <div className="col-md-6 d-none d-sm-block">
                            {imageSrc && (
                              <Fragment>
                                <span className="secondary-label">Posicione ou recorte a imagem:</span>
                                <span className="desc">Clique em cima da imagem quando a posição estiver perfeita</span>
                                <ReactCrop
                                  src={imageSrc}
                                  crop={crop}
                                  onImageLoaded={this.onImageLoaded}
                                  onComplete={this.onCropComplete}
                                  onChange={this.onCropChange}
                                />
                              </Fragment>
                            )}
                            {!imageSrc && currentImage && (
                              <Fragment>
                                <img className="ReactCrop__current-cover" src={currentImage} alt="Imagem de capa" />
                              </Fragment>
                            )}
                          </div>
                          <div className="col-6">
                            {croppedImageUrl && (
                              <Fragment>
                                <span className="secondary-label">Imagem cortada:</span>
                                <span className="desc">A capa aparecerá assim para os usuários</span>
                                <img alt="Crop" className="ReactCrop__result" src={croppedImageUrl} />
                              </Fragment>
                            )}
                          </div>
                        </div>
                      </Fragment>
                    ) : (
                      <Fragment>
                        <input
                          type="file"
                          accept="video/mp4"
                          name="videoSrc"
                          onChange={this.onSelectVideo}
                        />
                        {!videoSrc && currentVideo && (
                          <div className="card-video">
                            <Player
                              playsInline
                              src={currentVideo}
                              aspectRatio="auto"
                            />
                          </div>
                        )}
                      </Fragment>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <ButtonPanel>
                    <Link to="/panel/" className="btn btn-light">
                      Cancelar
                    </Link>
                    <input type="submit" className="btn btn-success" value="Salvar" />
                  </ButtonPanel>
                </div>
              </div>
            </form>
          </div>
          {showAlert && (
            <SweetAlert
              type={type}
              confirmBtnText={confirmBtnText}
              confirmBtnBsStyle={confirmBtnBsStyle}
              showCancel={showCancel}
              cancelBtnText={cancelBtnText}
              cancelBtnBsStyle={cancelBtnBsStyle}
              title={title}
              onConfirm={onConfirm}
              onCancel={this.closeAlert}
            >
              <ul>
                {messages.map(msg => (
                  <li key={msg}>{msg}</li>
                ))}
              </ul>
            </SweetAlert>
          )}
        </Container>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/EditPost/index.js